import {
  Button,
  Card,
  Col,
  Collapse,
  DatePicker,
  Descriptions,
  Dropdown,
  Form,
  Input,
  message,
  Modal,
  Popconfirm,
  Row,
  Spin,
  Table,
  Tooltip,
  Menu,
  Icon
} from 'antd';
import React from "react";
import { isArray, sanitizeFieldName } from "../../util/methods";
import './style.css';
import moment from "moment";
import AccessControl from "../../components/AccessControl";
import DocumentList from "../../components/DocumentList";
import QuickCloseModal from "./quickClose";
import ImagePreviewModal from "../../components/ImagePreviewModal";
const { Panel } = Collapse;

class Report extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      visibleForUncancelModal: false,
      documentData: [],
      pageSettingVisible: false,
      isOpenQuickJobCard: false,
      photoPreview: { visible: false, index: 0, photos: [] }
    };
  }

  openPhotoPreview = (photos, index) => {
    const list = (photos || [])
      .filter((p) => p && p.url)
      .map((p, i) => ({ url: p.url, name: p.name || `Photo ${i + 1}` }));
    this.setState({ photoPreview: { visible: true, index, photos: list } });
  };

  closePhotoPreview = () => {
    this.setState((prev) => ({ photoPreview: { ...prev.photoPreview, visible: false } }));
  };

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {

  }

  togglePageSettingVisible = () => {
    this.setState({
      pageSettingVisible: !this.state.pageSettingVisible
    })
  }

  componentWillUnmount() {
    this.props.clearProps();
  }

  handleCancelForQuickCloseModal = () => {
    this.setState({
      isOpenQuickJobCard: false
    });
  }

  handleOpenForQuickCloseModal = () => {
    this.setState({
      isOpenQuickJobCard: true
    });
  }

  dropdownData = (item) => {
    const columns = [
      {
        title: 'Spare Issue No.', dataIndex: 'spareIssueNo', key: 'spareIssueNo',
        render: (spareIssueNo) => {
          const type = spareIssueNo.includes('SPI') ? 'issue' : spareIssueNo.includes('TINV') ? 'TINV' : 'TPW';
          return (<Button size="small" type='link'
            onClick={() => this.props.clickVoucherNo(type, spareIssueNo)}>
            {spareIssueNo}
          </Button>)
        }
      },
      {
        title: 'Issued On',
        dataIndex: 'issuedOn',
        key: 'issuedOn',
        render: (date) => <div>{moment(date).format('DD-MM-YYYY')}</div>
      },
      { title: 'Quantity Issued', dataIndex: 'issued', key: 'issued' }
    ];
    return <React.Fragment>
      <Table
        style={{ width: '100%', backgroundColor: '#c0c9ff' }}
        columns={columns}
        dataSource={item}
        pagination={false}
        rowKey={(record) =>
          record.issued +
          record.spareIssueNo
        }
      />
    </React.Fragment>
  };

  changeRoute = (path) => {
    this.props.history.push(path);
  }

  linkHandlerForManpower = (record, page, route) => {
    const { match } = this.props;
    this.props.history.push(`/manpower-performance/edit/${record.mpPerformenceId}?backToJobCard=${match.params.id}`);
  };

  linkHandlerForActToINV = (record, page, route) => {
    const { match } = this.props;
    this.props.history.push(`/invoice-entry/edit/${record.invoiceEntryId}?backToJobCard=${match.params.id}`);
  };

  handleOk = e => {
    // console.log(e);
    this.setState({
      visible: false,
    });
  };

  cancelModal() {
    this.setState({
      visible: false,
    });
  }

  onChangeDate = (date, dateString) => {
    // console.log(date, dateString);
  }

  handleCancel = e => {
    // console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancelForUncancedModal = e => {
    this.setState({
      visibleForUncancelModal: false,
    });
  };

  cancelJobCard = () => {
    // message.info('Cancelled');
  };

  submitJCModalDateAndRemark = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, fieldsValue) => {
      if (!err) {
        const dateValue = {
          ...fieldsValue,
          'canceldate': fieldsValue['date-picker'].format('YYYY-MM-DD HH:mm:ss'),
        }
        const finalValue = {
          remark: dateValue.remark,
          cancelDate: dateValue.canceldate
        }
        this.props.cancelJCRemark(this.props.match.params.id, finalValue);
        this.setState({
          visible: false,
        });
      }
    });
  }

  submitJCModalDateAndRemarkForUncancel = (e) => {
    // console.log('submit');
    e.preventDefault();
    this.props.form.validateFields((err, fieldsValue) => {
      if (!err) {
        const dateValue = {
          ...fieldsValue,
          'canceldate': fieldsValue['date-picker'].format('YYYY-MM-DD HH:mm:ss'),
        }
        const finalValue = {
          remark: dateValue.remark,
          uncancelDate: dateValue.canceldate
        }
        this.props.unCancelledJobCard(this.props.match.params.id, finalValue);
        this.setState({
          visibleForUncancelModal: false,
        });
      }
    });
  };

  getDocumentData = (data) => {
    this.setState({ documentData: data });
    this.props.updateJobCardWithDocument(this.props.match.params.id, data);
  };

  // getSatDetails = (activityId) => {
  //   if(activityId) {
  //     this.props.fetchDetailsFromActivity(activityId);
  //   }
  // };

  // quickCloseJobCard = (jobCardId) => {
  //   console.log('jobCardId', jobCardId);
  // }

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      loading,
      deleteFromReportButton,
      editFromReportButton,
      cancelJCRemark,
      title,
      resource,
      form,
      filters,
      assetTypes,
      equipmentSubTypes,
      reports
    } = this.props;
    const { data: jobCard } = this.props;
    const {
      complaint, activitiesData, spareIssuesData, sparePartUnplannedData, sparePartPlannedData,
      dateUpdatesData, statusUpdatesData, documentData
    } = jobCard || {};
    console.log('Spare Issues Data', spareIssuesData);
    const { activities } = activitiesData || {};
    const { unplanned, planned } = spareIssuesData || {};
    const { dateStatus } = dateUpdatesData || {};
    const { updateStatus } = statusUpdatesData || {};
    const asset = (complaint && complaint.asset || {});
    const equipmentSubType = (asset && asset.equipmentSubType || {});
    const assetType = (equipmentSubType && equipmentSubType.assetType);
    const location = (complaint && complaint.location || {});
    const client = (complaint && complaint.client || {});
    const createdBy = (complaint && complaint.createdBy || {});
    const activitiesCost = (activitiesData && activitiesData.totalCost) || 0;
    const sparesCost = (spareIssuesData && spareIssuesData.totalCost) || 0;
    let totalCost = activitiesCost + sparesCost;
    let spareUnplannedDataSet = [], sparePartPlannedDataSet = [];
    let spareFinalCost = 0;
    const statusHistoryColumns = [
      {
        title: 'Update Date',
        dataIndex: 'date',
        key: 'date',
        render: (date) => {
          return <div>{moment(date).format('DD-MM-YYYY')}</div>
        }
      },
      {
        title: 'Updated By',
        dataIndex: 'updatedBy',
        key: 'updatedBy',
        render: (data) => <div>{data.name}</div>
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (data) => {
          return <div>{data.name}</div>
        }
      },
      {
        title: 'Details',
        dataIndex: 'details',
        key: 'details',
      },
    ];
    const statusHistoryData = updateStatus && updateStatus.length && updateStatus.map((item, index) => {
      return {
        key: index,
        date: item.date,
        updatedBy: item.updatedBy,
        status: item.status,
        details: item.details,
      }
    });

    const dateStatusColumns = [
      {
        title: 'UpdateDate',
        dataIndex: 'date',
        key: 'date',
        render: (date) => {
          return <div>{moment(date).format('DD-MM-YYYY')}</div>
        }
      },
      {
        title: 'Reason For Update',
        dataIndex: 'reasonForChangeInDate',
        key: 'reasonForChangeInDate',
      },
      {
        title: 'New Completion Date',
        dataIndex: 'newCompletionDate',
        key: 'newCompletionDate',
        render: (newCompletionDate) => {
          return <div>{moment(newCompletionDate).format('DD-MM-YYYY')}</div>
        }
      },
    ];
    const dateStatusData = dateStatus && dateStatus.length && dateStatus.map((item, index) => {
      return {
        key: index,
        date: item.date,
        reasonForChangeInDate: item.reasonForChangeInDate,
        newCompletionDate: item.newCompletionDate,
      }
    });
    // activity table data and columns
    const activityExpandedRowRender = (item) => {
      // console.log('item', item);
      const transferColumns = [{
        title: 'Transfer Date',
        dataIndex: 'attachedDate',
        key: 'attachedDate',
        render: (_, record) => record.attachedDate && moment(record.attachedDate).format('DD/MM/YYYY')
      },
      { title: 'STA No', dataIndex: 'subAssetTransferNo', key: 'subAssetTransferNo' },];
      const transferData = [];
      if (item.isOfTransferType && item.subAssetTransferRecord) {
        transferColumns.push(
          {
            title: 'Details',
            dataIndex: 'details',
            key: 'details',
            render: (_, record) => (<span><a key={record._id} href={`/sub-asset-transfer/edit/${record._id}`}
              target='_blank'>Details</a></span>)
          },
        );
        transferData.push({ ...{ key: 1 }, ...item.subAssetTransferRecord });
      } else {
        transferColumns.push({
          title: 'Details',
          dataIndex: 'details',
          key: 'details',
          render: (_, record) => (<span style={{ color: 'tomato' }}>{record.details}</span>)
        });
        transferData.push({ details: 'No STA Record found!' });
      }
      const columns = [
        // {title: 'MP reference', dataIndex: 'manpower', key: 'manpower'},
        // {title: 'MP reference', dataIndex: 'mpReferenceNumber', key: 'mpReferenceNumber',
        {
          title: 'MP reference', dataIndex: 'mpReferenceNumber',
          render: (value, record) => {
            return (
              <>
                {record && record.mpReferenceNumber ? (
                  <Tooltip placement="topLeft" title={"Manpower performance"}>
                    <Button className='button-for-job-card'
                      onClick={this.linkHandlerForManpower.bind(this, record, 'manpower', 'Open')}>
                      {'' + (record && record.mpReferenceNumber)}
                    </Button>
                  </Tooltip>
                ) : <div>NA</div>
                }
              </>
            );
          },
        },
        { title: 'Manpower', dataIndex: 'manpower', key: 'manpower' },
        {
          title: 'Work Details',
          dataIndex: 'workDetails',
          key: 'workDetails'
        },
        { title: 'Time Taken', dataIndex: 'time', key: 'time' },
        {
          title: 'Closed',
          dataIndex: 'status',
          key: 'status',
          render: (status) => <div>{status === 'Closed' ? 'Yes' : 'No'}</div>
        },
        {
          title: 'Date',
          dataIndex: 'date',
          key: 'date',
          render: (date) => <div>{moment(date).format('DD-MM-YYYY')}</div>
        },
        {
          title: 'Cost', dataIndex: 'cost', key: 'cost',
          render: (totalCost) => <div>{totalCost && totalCost.toLocaleString('en-IN', {
            maximumFractionDigits: 2,
            style: 'currency',
            currency: 'INR'
          }) || <span>&#8377;0.00</span>}</div>
        },
      ];

      const labourActivityColumns = [
        {
          title: 'Invoice No', dataIndex: 'invoiceEntryNumber',
          render: (value, record) => {
            return (
              <>
                {record && record.invoiceEntryNumber ? (
                  <Tooltip placement="topLeft" title={"Open Invoice Entry"}>
                    <Button className='button-for-job-card'
                      onClick={this.linkHandlerForActToINV.bind(this, record, 'invoiceEntry', 'Open')}>
                      {'' + (record && record.invoiceEntryNumber)}
                    </Button>
                  </Tooltip>
                ) : <div>NA</div>
                }
              </>
            );
          },
        },
        { title: 'Labour', dataIndex: 'name', key: 'name' },
        { title: 'Work Description', dataIndex: 'work', key: 'work' },
        { title: 'Cost Per Unit', dataIndex: 'unitRate', key: 'unitRate' },
        {
          title: 'No. Of Hours',
          dataIndex: 'noOfUnits',
          key: 'noOfUnits',
          render: item => (item % 1) !== 0 ? item && item.toFixed(2) || 0 : item
        },
        {
          title: 'Cost', dataIndex: 'cost', key: 'cost',
          render: (totalCost) => <div>{totalCost && totalCost.toLocaleString('en-IN', {
            maximumFractionDigits: 2,
            style: 'currency',
            currency: 'INR'
          }) || <span>&#8377;0.00</span>}</div>
        },
      ];

      const autoJcColumn = [
        {
          title: 'Auto JC Close Voucher No',
          dataIndex: 'voucherNo',
          key: 'voucherNo',
        },
        {
          title: 'Closing Date',
          dataIndex: 'closingDate',
          key: 'closingDate',
          render: (closingDate, record) => <div>{closingDate ? moment(closingDate).format('DD-MM-YYYY') : record.updatedAt ? moment(record.updatedAt).format('DD-MM-YYYY') : '-'}</div>
        },
        {
          title: 'Remark',
          dataIndex: 'remarks',
          key: 'remarks',
        },
        {
          title: 'Amount',
          dataIndex: 'amount',
          key: 'amount',
          render: (amount) => <div>{amount && amount.toLocaleString('en-IN', {
            maximumFractionDigits: 2,
            style: 'currency',
            currency: 'INR'
          }) || <span>&#8377;0.00</span>}</div>
        },
        {
          title: 'Photos',
          dataIndex: 'photos',
          key: 'photos',
          render: (photos) => {
            if (!photos || !photos.length) return 'No photos';
            return (
              <Dropdown
                overlay={
                  <Menu
                    style={{
                      maxHeight: '320px',
                      overflowY: 'auto',
                      overflowX: 'hidden'
                    }}
                  >
                    {photos.map((photo, index) => (
                      <Menu.Item key={index}>
                        <div
                          style={{ textAlign: 'center', cursor: 'pointer' }}
                          onClick={() => this.openPhotoPreview(photos, index)}
                        >
                          <img
                            src={photo.url}
                            alt={photo.name || 'Photo'}
                            style={{
                              width: '100px',
                              height: '100px',
                              objectFit: 'cover',
                              marginBottom: '8px'
                            }}
                          />
                          <div>{photo.name || 'Photo'}</div>
                        </div>
                      </Menu.Item>
                    ))}
                  </Menu>
                }
                trigger={['click']}
              >
                <Button type="link">
                  View Photos ({photos.length}) <Icon type="down" />
                </Button>
              </Dropdown>
            )
          },
        },
        {
          title: 'Documents',
          dataIndex: 'documents',
          key: 'documents',
          render: (documents) => {
            if (!documents || !documents.length) return 'No documents';
            return (
              <Dropdown
                overlay={
                  <Menu>
                    {documents.map((document, index) => (
                      <Menu.Item key={index}>
                        <a href={document && document.file && document.file.path} target="_blank" rel="noopener noreferrer">
                          <div style={{ textAlign: 'center' }}>
                            <div>{document && document.file && document.file.name || 'Document'}</div>
                          </div>
                        </a>
                      </Menu.Item>
                    ))}
                  </Menu>
                }
                trigger={['click']}
              >
                <Button type="link">
                  View Documents ({documents.length}) <Icon type="down" />
                </Button>
              </Dropdown>
            )

          },
        },
      ]

      const data = (item.manpowers && item.manpowers.length && item.manpowers.map((val, index) => {
        return {
          key: index,
          manpower: val.manpower,
          workDetails: val.workDetails,
          time: val.time,
          status: val.status,
          date: val.date,
          cost: val.cost,
          mpReferenceNumber: val.mpReferenceNumber,
          mpPerformenceId: val.mpPerformenceId,
        }
      })) || [];

      let labourData = (item.labours && item.labours.length && item.labours.map((val, index) => {
        return {
          key: index,
          name: val.name,
          work: val.work || 'NA',
          cost: val.cost,
          noOfUnits: val.noOfUnits,
          unitRate: val.unitRate,
          invoiceEntryNumber: val.invoiceNo,
          invoiceEntryId: val.invoiceEntryId,
        }
      })) || [];

      labourData = labourData.filter(val => val.noOfUnits && val.cost);

      const autoJcData = (item.autoJcCloseVoucher || []);
      // console.log('autoJcData', autoJcData);

      // const data = [];
      return <div>
        {item.isOfTransferType ? <Table columns={transferColumns} dataSource={transferData} pagination={false} /> : null}
        {data && data.length ? <Table columns={columns} dataSource={data} pagination={false} /> : null}
        {labourData && labourData.length ? <Table columns={labourActivityColumns} dataSource={labourData} pagination={false} /> : null}
        {autoJcData && autoJcData.length ? <Table columns={autoJcColumn} dataSource={autoJcData} pagination={false} /> : null}
      </div>
    };

    const activityColumns = [



      { title: 'Activity Type', dataIndex: 'activityType', key: 'activityType' },
      { title: 'Activity Type No.', dataIndex: 'activitySerialNo', key: 'activitySerialNo' },
      { title: 'Activity Description', dataIndex: 'activityDescription', key: 'activityDescription' },
      { title: 'Total Time', dataIndex: 'timeTaken', key: 'timeTaken' },
      {
        title: 'Total', dataIndex: 'totalCost', key: 'totalCost',
        render: (totalCost) => <div>{totalCost && totalCost.toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          style: 'currency',
          currency: 'INR'
        }) || <span>&#8377;0.00</span>}</div>
      },
      { title: 'Status', dataIndex: 'status', key: 'status' },
      { title: 'Last Allocated To', dataIndex: 'lastAllocatedTo', key: 'lastAllocatedTo' },
      { title: 'Initial Allocated To', dataIndex: 'initialAllocatedTo', key: 'initialAllocatedTo' },
      { title: 'Initial Estimated Time', dataIndex: 'initialTimeEstimate', key: 'initialTimeEstimate' },
      {
        title: 'Initial Cost Estimate', dataIndex: 'initialManpowerRate', key: 'initialManpowerRate',
        render: (totalCost) => <div>{totalCost && totalCost.toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          style: 'currency',
          currency: 'INR'
        }) || <span>&#8377;0.00</span>}</div>
      },
    ];

    const activityData = activitiesData && activitiesData.activities && activitiesData.activities.map((item, index) => {
      return {
        key: index,
        _id: item._id,
        initialCostEstimate: item.initialManpowerRate * item.initialTimeEstimate,
        activitySerialNo: item.activitySerialNo,
        activityDescription: item.description || '',
        activityType: item.activityType,
        isOfTransferType: item.isOfTransferType,
        subAssetTransferRecord: item.sat || null,
        timeTaken: item.timeTaken && item.timeTaken.toFixed(2),
        totalCost: item.totalCost,
        status: item.status,
        lastAllocatedTo: item.lastAllocatedTo,
        initialAllocatedTo: item.initialAllocatedTo,
        initialTimeEstimate: item.initialTimeEstimate,
        initialManpowerRate: item.initialManpowerRate,
        manpowers: item.manpowers,
        labours: item.labours,
        autoJcCloseVoucher: item.autoJcCloseVoucher,
      }
    });
    // spare issues data and columns
    const plannedColumns = [
      { title: 'Spare Name', dataIndex: 'spareName', key: 'spareName' },
      { title: 'Spares Type', dataIndex: 'spareType', key: 'spareType' },
      {
        title: 'Cost Per Unit', dataIndex: 'costPerUnit', key: 'costPerUnit',
        render: (totalCost) => <div>{totalCost && totalCost.toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          style: 'currency',
          currency: 'INR'
        }) || <span>&#8377;0.00</span>}</div>
      },
      {
        title: 'Total', dataIndex: 'totalCost', key: 'totalCost',
        render: (totalCost) => <div>{totalCost && totalCost.toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          style: 'currency',
          currency: 'INR'
        }) || <span>&#8377;0.00</span>}</div>
      },
      { title: 'Planned Qty', dataIndex: 'plannedQty', key: 'plannedQty' },
      {
        title: 'Quantity Issued',
        dataIndex: 'qtyIssued',
        key: 'qtyIssued',
        render: (qty) => qty && qty.length ? <Dropdown overlay={this.dropdownData.bind(this, qty)} trigger={['click']}>
          <a className="ant-dropdown-link" href="#">{qty.length ? qty.reduce((total, val) => {
            return total += val['issued'] ? val['issued'] : 0
          }, 0) : '--'}</a>
          {/*<a className="ant-dropdown-link" href="#">{qty.length ? qty[qty.length - 1].issued : '--'}</a>*/}
        </Dropdown> : <div> {qty} </div>
      },
    ];
    const plannedData = planned && planned.spares && planned.spares.map((item, index) => {
      return {
        key: index,
        spareName: item.spareName,
        spareType: item.spareType,
        costPerUnit: item.costPerUnit,
        totalCost: item.totalCost,
        plannedQty: item.plannedQty,
        qtyIssued: item.quantity,
      }
    });
    const unplannedColumns = [
      { title: 'Spare Name', dataIndex: 'spareName', key: 'spareName' },
      { title: 'Spares Type', dataIndex: 'spareType', key: 'spareType' },
      {
        title: 'Cost Per Unit', dataIndex: 'costPerUnit', key: 'costPerUnit',
        render: (totalCost) => <div>{totalCost && totalCost.toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          style: 'currency',
          currency: 'INR'
        }) || <span>&#8377;0.00</span>}</div>
      },
      {
        title: 'Total', dataIndex: 'totalCost', key: 'totalCost',
        render: (totalCost) => <div>{totalCost && totalCost.toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          style: 'currency',
          currency: 'INR'
        }) || <span>&#8377;0.00</span>}</div>
      },
      {
        title: 'Quantity Issued',
        dataIndex: 'qtyIssued',
        key: 'qtyIssued',
        render: (qty) => qty && isArray(qty) && qty.length ?
          (<Dropdown overlay={this.dropdownData.bind(this, qty)} trigger={['click']}>
            <a className="ant-dropdown-link" href="#">{qty.length ? qty.reduce((total, val) => {
              return total += val['issued'] ? val['issued'] : 0
            }, 0) : '--'}</a>
          </Dropdown>) : <div> {qty} </div>
      },
      // {
      //   title: '', dataIndex: 'invoice', key: 'invoice',
      // },
    ];


    const unplannedDataWithZero = unplanned && unplanned.spares && unplanned.spares.map((item, index) => {
      if (item /*&& item.totalCost && item.totalCost !== 0*/) {
        // console.log(item);
        return {
          key: index,
          spareName: item.spareName || '',
          spareType: item.spareType || '',
          costPerUnit: item.costPerUnit || 0,
          totalCost: item.totalCost || 0,
          qtyIssued: item.quantity || 0,
          // invoice: item['tinv'] ? item['tinv'] : item['tpw'] ? item['tpw'] : ''
        }
      }
    });

    const unplannedData = unplannedDataWithZero && unplannedDataWithZero.filter(item => item !== undefined);

    // console.log('unplannedData', unplannedData);

    const cancelDelete = () => {
      message.error('Cancelled');
    };
    /*const spareTpwColumns = [
      { title: 'Spare Name', dataIndex: 'spareName', key: 'spareName'},
      {title: 'No. Of Units', dataIndex: 'noOfUnits', key: 'noOfUnits'},
      { title: 'Cost Per Unit', dataIndex: 'costPerUnit', key: 'costPerUnit',
        render: (totalCost) => <div>{totalCost && totalCost.toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          style: 'currency',
          currency: 'INR'
        }) || <span>&#8377;0.00</span>}</div>},
      {
        title: 'Total', dataIndex: 'totalCost', key: 'totalCost',
        render: (totalCost) => <div>{totalCost && totalCost.toLocaleString('en-IN', {
          maximumFractionDigits: 2,
          style: 'currency',
          currency: 'INR'
        }) || <span>&#8377;0.00</span>}</div>
      },
    ];*/
    /*sparePartPlannedData && sparePartPlannedData.map((item, index) => {
      sparePartPlannedDataSet.push({
        key: `${index}`,
        spareName: item && item.spare,
        costPerUnit: item && item.unitRate,
        totalCost: item && item.totalCost,
        noOfUnits: item && item.noOfUnits,
      });
    });*/
    /*sparePartUnplannedData && sparePartUnplannedData.map((item, index) => {
        spareUnplannedDataSet.push({
          key: `${index}`,
          spareName: item && item.spare,
          costPerUnit: item && item.unitRate,
          totalCost: item && item.totalCost,
          noOfUnits: item && item.noOfUnits,
      });
    });*/
    /* let spareTotalUnplannedTpwCost = 0;
     spareUnplannedDataSet && spareUnplannedDataSet.map(item => {
       spareTotalUnplannedTpwCost = spareTotalUnplannedTpwCost + (item.totalCost || 0 );
     }); */

    const goBackOnTableWithOriginalFilter = () => {
      // localStorage.setItem('filter', JSON.stringify(this.props.initialQuery.filter));
      this.props.goBackFunctionForTable(this.props.initialQuery);
      this.props.history.goBack();
    }

    const documentColumns = [
      { title: 'Name', dataIndex: 'name', key: 'name' },
      {
        title: 'Renewal Date', dataIndex: 'renewalDate', key: 'renewalDate',
        render: (renewalDate) => <div>{renewalDate ? moment(renewalDate).format('DD-MM-YYYY') : "None"}</div>
      },
      {
        title: 'Document Date', dataIndex: 'documentDate', key: 'documentDate',
        render: (documentDate) => <div>{documentDate ? moment(documentDate).format('DD-MM-YYYY') : "None"}</div>
      },
      { title: 'Amount', dataIndex: 'amount', key: 'amount' },
      {
        title: 'Link to Document',
        key: 'href',
        render: (record) => {
          return (
            <a href={record.file && record.file.path} target="_blank">
              <span className="documentButton">
                Open Document
              </span>
            </a>
          );
        }
      },
      // {
      //   title: 'Action',
      //   render: (record) => {
      //     return (
      //       <>
      //         { record && record._id ? (
      //           <Tooltip placement="topLeft" title={"Edit Document"}>
      //             {/*<Button className='button-for-job-card' onClick={this.editDocumentHandler.bind(this,record)}>*/}
      //             <Button className='button-for-job-card' onClick={this.editDocumentHandler.bind(this,record)}
      //             >
      //               Edit Doc
      //             </Button>
      //           </Tooltip>
      //         ) : <div>NA</div>
      //         }
      //       </>
      //     );
      //   }
      // },
    ];

    // console.log('documentData', documentData);
    const jobCardsDocuments = documentData || [];


    documentData && documentData.length && documentData.map((item) => {
      const obj = {};
    });

    // console.log('jobCard', jobCard);
    const isOpenQuickJobCard = jobCard && jobCard.status === 'Open' && jobCard.activities && jobCard.activities.length === 1
      && jobCard.activities[0].activityType && jobCard.activities[0].activityType.name && jobCard.activities[0].activityType.name === "AutoJC"
      && jobCard.activities[0].status && jobCard.activities[0].status === 'Open';

    // console.log('isOpenQuickJobCard', isOpenQuickJobCard);
    return (
      <>
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics job-card-style`}>
          <div>
            <div style={{ justifyContent: "flex-start", textAlign: "left", marginBottom: '0px' }}>
              <Button type="primary"
                size='default'
                onClick={goBackOnTableWithOriginalFilter}
              >Back</Button>
            </div>
            <div style={{ justifyContent: "flex-end", textAlign: "right", marginBottom: '0px' }}>
              {isOpenQuickJobCard &&
                <AccessControl resource={'QuickCloseJobCard'} permissionNeeded={'c'}
                  roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                    return <>
                      <Tooltip placement="topLeft" title={"Quick Close"}>
                        <Button type="danger" style={{ marginRight: '10px' }}
                          size='default'
                          onClick={() => this.handleOpenForQuickCloseModal()}>Quick Close</Button>
                      </Tooltip>
                    </>
                  }} />
              }
              <AccessControl resource={this.props.resource} permissionNeeded={'u'}
                roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                  return <>
                    <Tooltip placement="topLeft" title={"Edit JobCard"}>
                      <Button type="primary"
                        size='default'
                        onClick={() => editFromReportButton(jobCard._id)}>Edit</Button>
                    </Tooltip>
                  </>
                }} />
              {jobCard && (jobCard.status === 'Open') &&
                <AccessControl resource={this.props.resource} permissionNeeded={'d'}
                  roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                    return <Popconfirm
                      title="Do you want to Cancel this jobCard ? "
                      onConfirm={() => {
                        this.setState({
                          visible: true,
                        });
                      }}
                      onCancel={this.cancelJobCard}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button style={{ marginLeft: '10px', background: "#008B8B", color: "#fff" }}
                        size='default'
                        disabled={jobCard && (jobCard.status === 'Cancelled' || jobCard.status === 'Closed')}
                      >Cancel</Button>
                    </Popconfirm>;
                  }} />
              }
              {jobCard && (jobCard.status === 'Cancelled') &&
                <AccessControl resource={this.props.resource}
                  permissionNeeded={'d'}
                  roles={this.props.authUser ? this.props.authUser.roles : []}
                  render={(props) => {
                    return <Popconfirm
                      title="Do you want to Uncancel this jobCard ? "
                      onConfirm={() => {
                        this.setState({
                          visibleForUncancelModal: true,
                        });
                      }}
                      // onCancel={this.cancelJobCard}
                      onCancel={() => {
                        this.setState({
                          visibleForUncancelModal: false,
                        })
                      }}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button style={{ marginLeft: '10px', background: "#008B8B", color: "#fff" }}
                        size='default'
                        disabled={jobCard.status === 'Closed'}
                      >Uncancel</Button>
                    </Popconfirm>;
                  }} />
              }

              <AccessControl resource={this.props.resource} permissionNeeded={'d'}
                roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                  return <Popconfirm
                    title="Are you sure you want to delete this record?"
                    onConfirm={() => {
                      deleteFromReportButton(jobCard._id);
                    }}
                    onCancel={cancelDelete}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button style={{ marginLeft: '10px' }} type="danger" size='default'>Delete</Button>
                  </Popconfirm>;
                }} />
            </div>
          </div>

          <div>
            <Descriptions
              title="Job Card Report"
              layout='vertical'
              bordered
              column={{ xxl: 6, xl: 6, lg: 6, md: 3, sm: 2, xs: 1 }}
            >
              <Descriptions.Item label="Job Card No.">{jobCard && jobCard.jobCardNo}</Descriptions.Item>
              <Descriptions.Item
                label="Asset Servicable">{complaint && complaint.assetUnservicable ? 'NO' : 'YES'}</Descriptions.Item>
              <Descriptions.Item label="Status"
                span={1}>
                <Tooltip placement="topLeft" title={"Open JobCard Closure"}>
                  <Button className='button-for-job-card'
                    onClick={() => this.changeRoute(`/job-card-closure/edit/${jobCard && jobCard._id}?backToModule=jobCard`)}>
                    {jobCard && jobCard.status && jobCard.status === 'Closed' ? 'CLOSED' : (jobCard && jobCard.statusTitle && sanitizeFieldName(jobCard.statusTitle)) || (jobCard && jobCard.status && jobCard.status.toUpperCase())}
                  </Button>
                </Tooltip>
              </Descriptions.Item>
              {
                jobCard && jobCard.status === 'Closed' ?
                  <Descriptions.Item
                    label="Date Closed On">{jobCard && moment(jobCard.closureDate || jobCard.updatedAt).format('DD-MM-YYYY')}</Descriptions.Item> :
                  <Descriptions.Item
                    label="Expected Closure Date" span={1}>
                    <Tooltip placement="topLeft" title={"Open JobCard date update"}>
                      <Button className='button-for-job-card'
                        onClick={() => this.changeRoute(`/job-card-date-update/edit/${jobCard && jobCard._id}?backToModule=jobCard`)}>
                        {dateUpdatesData && moment(dateUpdatesData.currentClosureDate || dateUpdatesData.originalClosureDate).format('DD-MM-YYYY')}
                      </Button>
                    </Tooltip>
                  </Descriptions.Item>
              }
              {
                jobCard && jobCard.status === 'Closed' ?
                  <Descriptions.Item
                    label="Closed in Days">{jobCard && jobCard.complaint && moment(jobCard.closureDate || jobCard.updatedAt).diff(moment(jobCard.complaint.complaintDate), 'days')}</Descriptions.Item> :
                  <Descriptions.Item
                    label="Days Since Complaint">{jobCard && jobCard.complaint && moment().diff(moment(jobCard.complaint.complaintDate), 'days')}</Descriptions.Item>
              }
              <Descriptions.Item label="Activities Cost">{activitiesCost && activitiesCost.toLocaleString('en-IN', {
                maximumFractionDigits: 2,
                style: 'currency',
                currency: 'INR'
              }) || <span>&#8377;0.00</span>}</Descriptions.Item>
              <Descriptions.Item label="Spares Cost">{sparesCost && sparesCost.toLocaleString('en-IN', {
                maximumFractionDigits: 2,
                style: 'currency',
                currency: 'INR'
              }) || <span>&#8377;0.00</span>}</Descriptions.Item>
              <Descriptions.Item label="Total Cost">{totalCost && totalCost.toLocaleString('en-IN', {
                maximumFractionDigits: 2,
                style: 'currency',
                currency: 'INR'
              }) || <span>&#8377;0.00</span>}</Descriptions.Item>

              {/*<Descriptions.Item label="Equipment No:" span={1}>{asset && asset.assetCode}</Descriptions.Item>*/}
              <Descriptions.Item label="Equipment No:">
                {asset && asset.assetCode ?
                  <Tooltip placement="topLeft" title={"Open Asset report"}>
                    <Button className='button-for-job-card'
                      onClick={() => this.changeRoute(`/asset/history-report/${asset && asset._id}`)}>
                      {asset && (asset.assetCode + '/' + asset.altName + '/' + asset.ownerCode)}
                    </Button>
                  </Tooltip> : ''
                }
              </Descriptions.Item>
              <Descriptions.Item
                label="Equipment Sub Type:">{equipmentSubType && equipmentSubType.name}</Descriptions.Item>
              <Descriptions.Item label="Equipment Type">{assetType && assetType.name}</Descriptions.Item>

              <Descriptions.Item label="Complaint No.">
                <Tooltip placement="topLeft" title={"Open Complaint"}>
                  <Button className='button-for-job-card'
                    onClick={() => this.changeRoute(`/complaint/edit/${complaint && complaint._id}?jobCardIdForBach=${jobCard._id}`)}>{complaint && complaint.complaintNo}</Button>
                </Tooltip>
              </Descriptions.Item>

              {/*<Descriptions.Item label="Complaint Date :" span={1}>*/}
              {/*  <Tooltip placement="topLeft" title={"Open JobCard date update"}>*/}
              {/*    <Button className='button-for-job-card' onClick={() => this.changeRoute(`/job-card-date-update/edit/${jobCard && jobCard._id}?backToModule=jobCard`)}>*/}
              {/*      {dateUpdatesData && moment(dateUpdatesData.currentClosureDate || dateUpdatesData.originalClosureDate).format('DD-MM-YYYY')}*/}
              {/*    </Button>*/}
              {/*  </Tooltip>*/}
              {/*</Descriptions.Item>*/}


              <Descriptions.Item label="Complaint Date">
                {complaint && complaint.complaintDate && moment(complaint.complaintDate).format('DD-MM-YYYY')}
              </Descriptions.Item>
              <Descriptions.Item label="Complaint Created By">{createdBy && createdBy.name}</Descriptions.Item>
              <Descriptions.Item label="Cause of Damage">{complaint && complaint.causeOfDamage}</Descriptions.Item>
              <Descriptions.Item label="Unserviceable">{complaint && complaint.assetUnservicable ? 'YES' : 'NO'}</Descriptions.Item>
              <Descriptions.Item
                label="Complaint Details" span={1}>{complaint && complaint.detailsOfComplaint}</Descriptions.Item>
            </Descriptions>

            <Descriptions title="Current Status"
              style={{ marginTop: '30px' }}
              bordered
              size={'small'}
              column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}>
              {
                statusUpdatesData && statusUpdatesData.statusUpdateOn ?
                  <Descriptions.Item label="Status Update On:">
                    {statusUpdatesData && moment(statusUpdatesData.statusUpdateOn).format('DD-MM-YYYY')}
                  </Descriptions.Item> : ''
              }
              {
                statusUpdatesData && statusUpdatesData.statusUpdatedBy ?
                  <Descriptions.Item label="Status Updated By:">
                    {statusUpdatesData && statusUpdatesData.statusUpdatedBy}
                  </Descriptions.Item> : ''
              }
              {
                statusUpdatesData ? <Descriptions.Item label="Present Status: ">
                  <Tooltip placement="topLeft" title={"Open JobCard Status"}>
                    <Button className='button-for-job-card'
                      onClick={() => this.changeRoute(`/job-card-status/edit/${jobCard && jobCard._id}?moduleName=jobcard`)}>
                      {(() => {
                        const status = statusUpdatesData && statusUpdatesData.presentStatus;
                        if (status === 'ClosedPendingInvoice') {
                          return 'Closed - Pending Invoice';
                        } else if (status === 'ClosedPendingInvoiceReopen') {
                          return 'Closed - Pending Invoice - Reopened';
                        } else {
                          return status || <small style={{ 'color': 'red' }}>Invalid Status</small>;
                        }
                      })()}
                    </Button>
                  </Tooltip>

                </Descriptions.Item> : ''
              }
              {
                statusUpdatesData && statusUpdatesData.presentStatusDetails ?
                  <Descriptions.Item label="Present Status Details: ">
                    {statusUpdatesData && statusUpdatesData.presentStatusDetails}
                  </Descriptions.Item> : ''
              }
              {
                statusUpdatesData && statusUpdatesData.presentReviewDate ?
                  <Descriptions.Item label="Review Date: ">
                    {statusUpdatesData && statusUpdatesData.presentReviewDate && moment(statusUpdatesData.presentReviewDate).format('DD-MM-YYYY')}
                  </Descriptions.Item> : ''
              }
              {/*{*/}
              {/*  this.props && this.props.data && this.props.data.cancelDate ?*/}
              {/*    <Descriptions.Item label="Cancel Date: " span={3}>*/}
              {/*      {this.props.data && this.props.data.cancelDate && moment(this.props.data.cancelDate).format('DD-MM-YYYY')}*/}
              {/*    </Descriptions.Item> : ''*/}
              {/*}*/}
              {/*{*/}
              {/*  this.props && this.props.data && this.props.data.remark ?*/}
              {/*    <Descriptions.Item label="Remark: " span={3}>*/}
              {/*      {this.props.data && this.props.data.remark}*/}
              {/*    </Descriptions.Item> : ''*/}
              {/*}*/}
            </Descriptions>
          </div>

          <div>
            <Collapse bordered={false}>
              {/*Documents in JobCard*/}
              <Panel header={
                <Row className='job-card-row'>
                  <Col xs={24} sm={12} md={8} lg={3}>
                    <div className='job-card-details content-row-style'>
                      <div>Documents</div>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={3}>
                    <DocumentList history={this.props.history}
                      match={this.props.match}
                      key={'documents'}
                      item={filters['documents']}
                      form={form}
                      resource='jobCardReport'
                      comeFrom='jobCardReport'
                      getDocumentData={this.getDocumentData} />
                  </Col>
                </Row>
              } key="documents">

                {(jobCardsDocuments && jobCardsDocuments.length > 0 &&
                  <Table dataSource={jobCardsDocuments || []} columns={documentColumns || []}
                    pagination={false} />) || "No documents found!"}
              </Panel>

              {/* Status Update */}
              <Panel header={
                <Row className='job-card-row'>
                  <Col xs={24} sm={12} md={8} lg={6}>
                    <div className='job-card-details'>
                      <div className='content-row-style'>Status Update History</div>
                    </div>
                  </Col>
                </Row>
              } key="5">
                <Table dataSource={statusHistoryData || []} columns={statusHistoryColumns} pagination={false} />
              </Panel>

              {/* Activities Data for Job Card */}
              <Panel header={
                <Row className='job-card-row'>
                  <Col xs={24} sm={12} md={8} lg={3}>
                    <div className='job-card-details content-row-style'>
                      <div>Activities</div>
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8} lg={6}>
                    <div className='job-card-details'>
                      <div className='content-row-style'>Time Taken :</div>
                      <div>&nbsp;{activitiesData && activitiesData.timeTaken && activitiesData.timeTaken.toFixed(2) || 0}</div>
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8} lg={6}>
                    <div className='job-card-details'>
                      <div className='content-row-style'>Total :</div>
                      <div>&nbsp;{activitiesData && activitiesData.totalCost && activitiesData.totalCost.toLocaleString('en-IN', {
                        maximumFractionDigits: 2,
                        style: 'currency',
                        currency: 'INR'
                      }) || <span>&#8377;0.00</span>}</div>
                    </div>
                  </Col>
                </Row>
              } key="1">
                <Table
                  columns={activityColumns}
                  expandedRowRender={activityExpandedRowRender}
                  dataSource={activityData}
                  pagination={false}
                />
              </Panel>

              {/* Spare Issues data for Job Card*/}
              <Panel header={
                <Row className='job-card-row'>
                  <Col xs={24} sm={12} md={8} lg={3}>
                    <div className='job-card-details'>
                      <div className='content-row-style'>Spares</div>
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8} lg={6}>
                    <div className='job-card-details'>
                      <div className='content-row-style'>Total :</div>
                      <div>&nbsp;{spareIssuesData && spareIssuesData.totalCost && spareIssuesData.totalCost.toLocaleString('en-IN', {
                        maximumFractionDigits: 2,
                        style: 'currency',
                        currency: 'INR'
                      }) || <span>&#8377;0.00</span>}</div>
                    </div>
                  </Col>
                </Row>
              } key="2">

                {/* Planned Spares*/}
                <Collapse bordered={false}>
                  <Panel header={
                    <Row className='job-card-row'>
                      <Col xs={24} sm={12} md={8} lg={5}>
                        <div className='job-card-details'>
                          <div className='content-row-style'>Planned Spares</div>
                        </div>
                      </Col>

                      <Col xs={24} sm={12} md={8} lg={6}>
                        <div className='job-card-details'>
                          <div className='content-row-style'>Total :</div>
                          <div>&nbsp;{planned && planned.cost && planned.cost.toLocaleString('en-IN', {
                            maximumFractionDigits: 2,
                            style: 'currency',
                            currency: 'INR'
                          }) || <span>&#8377;0.00</span>}</div>
                        </div>
                      </Col>
                    </Row>
                  } key="1">
                    <Table dataSource={plannedData} columns={plannedColumns} pagination={false} />
                  </Panel>
                </Collapse>

                {/* Unplanned Spares*/}
                <Collapse bordered={false}>
                  <Panel header={
                    <Row className='job-card-row'>
                      <Col xs={24} sm={12} md={8} lg={5}>
                        <div className='job-card-details'>
                          <div className='content-row-style'>Unplanned Spares</div>
                        </div>
                      </Col>

                      <Col xs={24} sm={12} md={8} lg={6}>
                        <div className='job-card-details'>
                          <div className='content-row-style'>Total :</div>
                          <div>&nbsp;{unplanned && unplanned.cost && unplanned.cost.toLocaleString('en-IN', {
                            maximumFractionDigits: 2,
                            style: 'currency',
                            currency: 'INR'
                          }) || <span>&#8377;0.00</span>}</div>
                        </div>
                      </Col>
                    </Row>
                  } key="1">
                    <Table dataSource={unplannedData} columns={unplannedColumns} pagination={false} />
                  </Panel>
                </Collapse>
              </Panel>

              <Panel header={
                <Row className='job-card-row'>
                  <Col xs={24} sm={12} md={8} lg={3}>
                    <div className='job-card-details'>
                      <div className='content-row-style'>Date Updates</div>
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8} lg={7}>
                    <div className='job-card-details'>
                      <div className='content-row-style'>Original Closure Date :</div>
                      <div>&nbsp;{dateUpdatesData && moment(dateUpdatesData.originalClosureDate).format('DD-MM-YYYY')}</div>
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8} lg={8}>
                    <div className='job-card-details'>
                      <div className='content-row-style'>Current/Actual Closure Date :</div>
                      <div>&nbsp;{dateUpdatesData && dateUpdatesData.currentClosureDate && moment(dateUpdatesData.currentClosureDate).format('DD-MM-YYYY')}</div>
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8} lg={6}>
                    <div className='job-card-details'>
                      <div
                        className='content-row-style'>{`${dateUpdatesData && dateUpdatesData.delay < 0 ? 'Delay' : 'Early'} Days`} :
                      </div>
                      <div>&nbsp;{dateUpdatesData && Math.abs(dateUpdatesData.delay)}</div>
                    </div>
                  </Col>
                </Row>
              } key="3">

                <Table dataSource={dateStatusData || []} columns={dateStatusColumns} pagination={false} />

              </Panel>
            </Collapse>
          </div>


          <Modal
            title="Cancel JobCard"
            visible={this.state.visible}
            // onOk={this.handleOk}
            onCancel={this.handleCancel}
            footer={null}
          >
            <Form wrapperCol={{ span: 16 }} onSubmit={this.submitJCModalDateAndRemark}
            //onFinishFailed={onFinishFailed}
            >
              <Form.Item label="Cancel Date">
                {getFieldDecorator('date-picker', {
                  rules: [{ required: true }],
                })(<DatePicker />)}
              </Form.Item>
              <Form.Item label='Remark'>
                {getFieldDecorator('remark', {
                  rules: [{ required: true, message: 'Enter remark!' }],
                })(
                  <Input />
                )}
              </Form.Item>
              <Form.Item
                wrapperCol={{
                  offset: 8,
                  span: 16,
                }}
              >
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Modal>

          <Modal
            title="Uncanceled JobCard"
            visible={this.state.visibleForUncancelModal}
            // onOk={this.handleOk}
            onCancel={this.handleCancelForUncancedModal}
            footer={null}
          >
            <Form
              wrapperCol={{
                span: 16,
              }}
              onSubmit={this.submitJCModalDateAndRemarkForUncancel}
            //onFinishFailed={onFinishFailed}
            >
              <Form.Item label="Uncanceled Date">
                {getFieldDecorator('date-picker', {
                  rules: [{ required: true }],
                })(<DatePicker />)}
              </Form.Item>
              <Form.Item label='Remark'>
                {getFieldDecorator('remark', {
                  rules: [{ required: true, message: 'Enter remark!' }],
                })(
                  <Input />
                )}
              </Form.Item>
              <Form.Item wrapperCol={{
                offset: 8,
                span: 16,
              }}>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Modal>

          {isOpenQuickJobCard && <QuickCloseModal
            visible={this.state.isOpenQuickJobCard}
            onCancel={this.handleCancelForQuickCloseModal}
            // form={this.props.form}
            match={this.props.match}
            history={this.props.history}
            filters={this.props.filters}
            loading={this.props.loading}
            fetchJobCardData={this.props.fetch.bind(this, this.props.match.params.id)}
            jobCardData={jobCard}
          />}
        </Card>
      </Spin>
      <ImagePreviewModal
        visible={this.state.photoPreview.visible}
        photos={this.state.photoPreview.photos}
        initialIndex={this.state.photoPreview.index}
        onClose={this.closePhotoPreview}
      />
      </>
    );
  }
}

Report = Form.create({ name: 'horizontal_login' })(Report);
export default Report;
